import { SimpleGrid, Text } from '@chakra-ui/react'
import React from 'react'
import NotAvailable from '../NotAvailable'

const ProjectItem = ({ label, value }) => {
    return (
        <>
            <Text fontSize='xs' color="gray.500">
                {label}
            </Text>
            {
                Array.isArray(value) ? <SimpleGrid columns={3} spacing={1}>
                    {
                        value === 0 ? <NotAvailable /> :
                            value.map((vlu, idx) => <Text maxWidth="250px" key={idx} as="span" fontSize='sm'>{vlu} </Text>)
                    }
                </SimpleGrid> : <>
                    <Text fontSize='sm'>
                        {value ? value : <NotAvailable />}
                    </Text>
                </>
            }
        </>
    )
}

export default ProjectItem